import React, { useContext } from "react";
import TopBar from "../../../components/TopBarComponent/Topbar";
import { Container } from "react-bootstrap";
import { StatusERTContext } from "../StatusERTView";
import LeftArrow from "../../../assets/images/leftArrow.svg";
import TableBody from "../../../constants/dummyData.json";
import DataTable from "../../../components/DataTableComponent/DataTable";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import "./statusERT.css";
import { baseURL } from "../../../api/Axios";
import { Spinner } from "react-bootstrap";

const StatusERTPage = ({ textContents }) => {
  const {
    goBack,
    evacuactionDetailPage,
    previousPage,
    statusCategory,
    showAlert,
    setShowAlert,
    ertExcelData,
    zoneNewExcel,
    dataLoad,
    alertMessage,
    logout,
    handleAlertSubmit,
    emptyERTAlert,
    spinnerStatus,
    statusCode,
  } = useContext(StatusERTContext);
  const ERTdata = TableBody.ERTcount;

  const tableHeader = [
    {
      title: "ERT Name",
      prop: "categoryName",
      cell: (row) => (
        <div
          className="ertHeaderEvacuation"
          onClick={() => {
            row.totalCount
              ? evacuactionDetailPage(row.categoryName, row.ertId)
              : emptyERTAlert();
          }}
        >
          {" "}
          {row.categoryName}
        </div>
      ),
    },
    { title: "Total Count", prop: "totalCount" },
    { title: "PVC Compounding (Zone 1)", prop: "zoneOneCount" },
    { title: "Wires Factory (Zone 2)", prop: "zoneTwoCount" },
  ];

  return (
    <div>
      <TopBar />
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => handleAlertSubmit()
        }
      />
      <Container>
        <div className="filterContainerZoneERT">
          <div className="arrowContainerZoneERT" onClick={() => goBack()}>
            <img src={LeftArrow} alt="img" className="leftArrowZoneERT" />
          </div>
          <div className="filterByContainerZoneERT">
            <span className="filterByZoneText">
              {previousPage == "status" ? textContents.filteredByERT : "ERT"}
            </span>
            <div className="text-align">
              <span className="download-text">
                <a
                  className={
                    zoneNewExcel ? "excel-download" : "disabled-button"
                  }
                  href={
                    zoneNewExcel ? `${baseURL}/excel/${zoneNewExcel}` : null
                  }
                >
                  <img
                    className="excel-icon"
                    src={ExcelIcon}
                    alt="Excel-icon"
                  />
                  {spinnerStatus ? <Spinner size="sm" /> : "Download Excel"}
                </a>
              </span>
            </div>
          </div>
        </div>

        <div className="tableContainerStatusERT">
          <DataTable
            tableData={statusCategory}
            header={tableHeader}
            isPagination={false}
            loadingStatus={dataLoad}
          />
        </div>
      </Container>
    </div>
  );
};

export default StatusERTPage;
